import React, { useCallback, useEffect, useRef, useState } from "react";
import { OPEN_SIGNATURE_MODAL } from "../redux/actions/actionTypes";
import { useDispatch } from "react-redux";
import CustomButton from "./Button";

const SignatureComponent = ({
  id,
  userSignauter,
  handleOnSignatureClick,
  removeSignatures,
  loading,
  onChange,
  disabled,
  allButtonIds,
}) => {
  const dispatch = useDispatch();
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const handleToggleDropdown = (dropdownId) => {
    setOpenDropdownId((prev) => (prev === dropdownId ? null : dropdownId));
  };

  const ref = useRef(null);

  const handleOnSignatureChange = () => {
    if (onChange) {
      onChange();
    } else
      dispatch({
        type: OPEN_SIGNATURE_MODAL,
      });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const scrollToNext = useCallback(() => {
    if (!allButtonIds) return;

    const thisIndex = allButtonIds.indexOf(id);
    const nextIndex = thisIndex + 1;
    const nextId = allButtonIds[nextIndex];

    const element = document.getElementById(nextId);

    if (element) {
      const rect = element.getBoundingClientRect();
      const offsetY = window.scrollY || window.pageYOffset;
      window.scrollTo({
        top: offsetY + rect.top - 50,
        behavior: "smooth",
      });
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 100);
      element.focus({ preventScroll: false });
    } else {
      console.warn("Next element not found:", nextId);
    }
  }, [allButtonIds, id]);

  const isLastSignatureBeforeSubmit = () => {
    const isLast =
      allButtonIds?.indexOf(id) === allButtonIds?.length - 2 &&
      allButtonIds?.[allButtonIds?.length - 1] === "submit";
    return isLast;
  };

  return (
    <div className="relative inline-block w-full" ref={ref} id={id}>
      {userSignauter && (
        <>
          <div className="border item-center">
            <img
              className="object-cover w-full max-h-96"
              src={userSignauter}
              alt="User Signature"
              onClick={() => (disabled ? null : handleToggleDropdown(id))}
            />

            {openDropdownId === id && (
              <div className="absolute right-0 mt-2 w-full bg-white border border-gray-200 shadow-lg">
                <button
                  className="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                  onClick={() => handleOnSignatureChange()}
                >
                  Change
                </button>
                {loading ? (
                  <div class="flex space-x-2 justify-center items-center bg-white  dark:invert">
                    <div class="h-3 w-3 bg-red-800 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                    <div class="h-3 w-3 bg-red-800 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                    <div class="h-3 w-3 bg-red-800 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                  </div>
                ) : (
                  <button
                    className="block w-full px-4 py-2 text-sm text-left text-red-600 hover:bg-red-100"
                    onClick={removeSignatures}
                  >
                    Delete
                  </button>
                )}
              </div>
            )}
          </div>
          {!disabled ? (
            <div className="w-full flex justify-end items-center">
              {!isLastSignatureBeforeSubmit() && (
                <CustomButton
                  onClick={() => (disabled ? null : scrollToNext())}
                  label="Next"
                  labelColor="black"
                />
              )}
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
};

export default SignatureComponent;
